/** @jsx jsx */
import { jsx } from '@emotion/core'
import { DatePicker, Select, Button, message } from 'antd'
import { getApiTargetInfo } from 'core'
import { Content, CriteriaRow, FullHeightSizer, Title } from 'core/screen-util'
import React, { useState, useContext, useEffect } from 'react'
import R from 'ramda'
import { connect } from 'react-redux'
import {
  DataContext,
  DatePickerContext,
  ErrorContext,
  SpinContext,
} from 'context'
import {
  solarPlantSelection,
  solarLevel2Validation,
  getSolarInverterGroup,
} from 'api/pgads'

import {
  JcTmpErrorTable,
  isErrorContains,
} from 'core/component/JcTmpErrorDialog'
import { getValidPlantList } from './util'

const SolarLevel2Validation = ({ targetInfo }) => {
  const { setSelectedDate, selectedDate } = useContext(DatePickerContext)
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const [plantSelectionData, setPlantSelectionData] = useState([])
  const {
    selectedSolarPlant,
    setSelectedSolarPlant: setPlantSelected,
  } = useContext(DataContext)
  const plantSelected = Array.isArray(selectedSolarPlant)
    ? selectedSolarPlant[0]
    : selectedSolarPlant
  const [data, setData] = useState([])
  const clearData = _ => {
    setData([])
  }

  useEffect(
    _ => {
      solarPlantSelection(targetInfo)({
        year: selectedDate.format('YYYY'),
        month: selectedDate.format('MM'),
      }).fork(setError, data => {
        setPlantList(data)
        // const sd = R.sortBy(R.prop('plantName'), data)
        // setPlantSelectionData(sd)
        // if (!plantSelected && sd[0] && sd[0].plantId)
        //   setPlantSelected(sd[0].plantId)
      })
    },
    [targetInfo, selectedDate, setError, plantSelected]
  )
  const [plantList, setPlantList] = useState([])
  const [inverterGroupList, setInverterGroupList] = useState([])

  useEffect(
    _ => {
      let stoList = []

      stoList = getValidPlantList(plantList, inverterGroupList, [])
      setPlantSelectionData(stoList)

      const isValidSelection = stoList.some(p => p.plantId === plantSelected)
      if (!isValidSelection && stoList[0] && stoList[0].plantId) {
        if (plantSelected !== stoList[0].plantId) {
          setPlantSelected([stoList[0].plantId])
        }
      }
    },
    [inverterGroupList, plantList, plantSelected, setPlantSelected]
  )
  useEffect(
    _ => {
      getSolarInverterGroup(targetInfo).fork(setError, setInverterGroupList)
    },
    [setError, targetInfo]
  )

  const onLevel2Validation = _ => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    setSpinning(true)
    solarLevel2Validation(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
    }).fork(setError, data => {
      setSpinning(false)
      setData(data)
      if (data.length <= 0 || !isErrorContains(data)) {
        message.info('Level 2 Validation completed successfully.')
      }
    })
  }
  return (
    <div>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '300px 200px 200px auto auto',
            gap: '5px',
          }}
        >
          <Title> Solar Level 2 Validation</Title>
          <Select
            showSearch
            value={plantSelected}
            style={{ width: '100%' }}
            onChange={plantId => {
              setPlantSelected([plantId])
              clearData()
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {R.sortBy(R.prop('plantName'), plantSelectionData).map(
              ({ plantName, plantId }) => (
                <Select.Option key={plantId} value={plantId}>
                  {plantName}
                </Select.Option>
              )
            )}
          </Select>
          <DatePicker.MonthPicker
            allowClear={false}
            style={{ width: '100%' }}
            format="MMMM-YYYY"
            value={selectedDate}
            onChange={d => {
              setSelectedDate(d.endOf('month'))
              clearData()
            }}
          />
          <Button
            type="primary"
            onClick={onLevel2Validation}
            icon="database"
            // style={{ width: '100%' }}
          >
            Level 2 Validation
          </Button>
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={200} widthOffset={20}>
        {({ height, width }) => (
          <Content style={{ padding: '10px', height, width }}>
            <JcTmpErrorTable errors={data} scroll={{ y: height - 80 }} />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarLevel2Validation)
